import React, { useEffect, useState, useRef } from 'react';
import { TwitterTweetEmbed } from 'react-twitter-embed';
import { Container, Row, Col, Spinner, Carousel, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// import { fetchTweetData } from '../../firebase/functions';
// import thumbnail from '../../assets/images/content/thumbnail.png';
import { Typography, Box, IconButton } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { getTweetIDs } from '../../firebase/functions';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

function TwitterWall() {
  // track viewport to keep widths responsive and reduce height on small screens
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const { t, i18n } = useTranslation();
  const sliderRef = useRef(null);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // Manual navigation functions
  const goToPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const goToNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  // const statictweetData = [
  //   '1834097904845234564',
  //   '1833734380814033284',
  //   '1834089105501630940',
  //   '1834089105501630940',
  // ];
  const [tweetstatic, setTweetstatic] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const res = await getTweetIDs();
      if (res.length > 0) {
        setTweetstatic(res.map((o) => o.tweet_id));
      }
    };
    getData();
    // setTweetstatic(statictweetData);
  }, []);

  // (old settings not used)

  const tweetCount = tweetstatic.length;
  const maxSlidesToShow = viewportWidth > 1200 ? 4 : viewportWidth > 768 ? 2 : 1;
  const actualSlidesToShow = Math.min(tweetCount, maxSlidesToShow);

  // responsive width; smaller width => shorter tweet height
  const slidesForWidth = Math.max(1, actualSlidesToShow || 1);
  const tweetWidth = Math.min(Math.round((viewportWidth * 0.9) / slidesForWidth), 520);

  // cap the visible height so the section doesn't stretch the page
  const TWEET_MAX_H = { xs: 420, sm: 520, md: 560 };

  const carouselConfig = {
    dots: tweetCount > actualSlidesToShow,
    infinite: tweetCount > actualSlidesToShow,
    speed: 500,
    slidesToShow: actualSlidesToShow,
    slidesToScroll: 1,
    autoplay: tweetCount > 4,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false,
    adaptiveHeight: false, // keep slider height stable
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(tweetCount, 1),
          infinite: tweetCount > 1,
          dots: tweetCount > 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(tweetCount, 2),
          infinite: tweetCount > 2,
          dots: tweetCount > 2,
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        background:
          'linear-gradient(45deg, rgba(20, 23, 26, 1), rgba(101, 119, 134, 1), rgba(170, 184, 194, 1), rgba(225, 232, 237, 1))',
        width: '100%',
        backdropFilter: 'blur(5px)',
        paddingBottom: { xs: '16px', sm: '20px', md: '10px' }, // less vertical space
      }}
    >
      <div
        className="hashtag-div  "
        style={{
          paddingTop: '1.2%', // less top space
        }}
      >
        <Typography
          variant="h1"
          className="main-heading my-2"
          style={{
            whiteSpace: 'nowrap',
            fontWeight: '700',
            fontFamily: 'Roboto',
            textAlign: 'center',
            color: '#3939A0',
            color: 'white',
          }}
        >
          {t('twitter_media_feed')}
        </Typography>
        <Container style={{ justifyContent: 'center', display: 'flex', marginTop: '1.2%' }}>
          <Row style={{ margin: '0.8%' }}>
            <Col
              xs={12}
              md={6}
              lg={3}
              className="target_units_sub text-center"
              style={{ color: 'white', fontSize: '20px' }}
            >
              #SHS2026
            </Col>
            <Col
              xs={12}
              md={6}
              lg={4}
              className="target_units_sub text-center"
              style={{ color: 'white', fontSize: '20px' }}
            >
              #Swachhotsav
            </Col>
            <Col
              xs={12}
              md={6}
              lg={5}
              className="target_units_sub text-center"
              style={{ color: 'white', fontSize: '20px' }}
            >
              #SwachhataHiSeva2026
            </Col>
          </Row>
        </Container>
      </div>

      <Container
        style={{
          marginBottom: '1%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          zIndex: 22,
        }}
      >
        {/* Previous Button */}
        {tweetCount > 1 && (
          <IconButton
            onClick={goToPrev}
            sx={{
              position: 'absolute',
              left: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              color: '#3939A0',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
                transform: 'translateY(-50%) scale(1.1)',
              },
              width: 50,
              height: 50,
              border: '2px solid rgba(57, 57, 160, 0.2)',
            }}
          >
            <ArrowBackIos sx={{ fontSize: 22, marginLeft: '3px' }} />
          </IconButton>
        )}

        <Container
          style={{
            marginBottom: '1%',
            padding: '2px',
            maxWidth: '90%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {tweetCount > 0 && (
            <Box
              sx={{
                width: '100%',
                // hard cap the visible height of the carousel
                '& .slick-list': { maxHeight: TWEET_MAX_H, overflow: 'hidden' },
                '& .slick-track': { display: 'flex' },
                '& .slick-slide > div': { display: 'flex', justifyContent: 'center' },
              }}
            >
              <Slider ref={sliderRef} {...carouselConfig}>
                {tweetstatic.map((item) => (
                  <Box
                    key={item}
                    sx={{ px: 1, width: '100%', display: 'flex', justifyContent: 'center' }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        maxHeight: TWEET_MAX_H,
                        overflow: 'hidden',
                      }}
                    >
                      <TwitterTweetEmbed
                        tweetId={item}
                        placeholder={
                          <Spinner animation="border" role="status">
                            <span className="sr-only"></span>
                          </Spinner>
                        }
                        options={{
                          align: 'center',
                          conversation: 'none',
                          cards: 'hidden',
                          dnt: true,
                          width: tweetWidth,
                        }}
                      />
                    </Box>
                  </Box>
                ))}
              </Slider>
            </Box>
          )}
        </Container>

        {/* Next Button */}
        {tweetCount > 1 && (
          <IconButton
            onClick={goToNext}
            sx={{
              position: 'absolute',
              right: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              color: '#3939A0',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
                transform: 'translateY(-50%) scale(1.1)',
              },
              width: 50,
              height: 50,
              border: '2px solid rgba(57, 57, 160, 0.2)',
            }}
          >
            <ArrowForwardIos sx={{ fontSize: 22 }} />
          </IconButton>
        )}
      </Container>
    </Box>
  );
}

export default TwitterWall;
